import api from '~api/api'
import { AssetType, IApiResponse } from '~types'

export interface IUploadAssetResponse {
  key: string
  url: string
  is_secure: boolean
  accessible_url: string
}

export const uploadFile = async (
  userId: string,
  ownerId: string,
  file: File,
  assetType: AssetType,
  caseHandle: string | null,
  caseId: string | null,
  isSecure: boolean = false,
): Promise<IUploadAssetResponse> => {
  try {
    const formData = new FormData()

    formData.append('user_id', userId)
    formData.append('owner_id', ownerId)
    formData.append('file', file)
    formData.append('is_secure', isSecure.toString())
    formData.append('asset_type', assetType)
    if (caseHandle) {
      formData.append('case_handle', caseHandle)
    }
    if (caseId) {
      formData.append('case_id', caseId)
    }

    const response = await api.post<IApiResponse<IUploadAssetResponse>>(
      '/core/upload-asset/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    if (!response.data) {
      throw new Error('No data returned from upload API')
    }
    return response.data as IUploadAssetResponse
  } catch (error: unknown) {
    console.error('Error uploading asset:', error)
    throw error
  }
}
